/**
 * @generated SignedSource<<6db33c1d618bbb1aa152daf80f917a30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfirmSupplierServicePeriodProposalsInput = {
  id: string;
  upToMonth?: string | null | undefined;
};
export type ConfirmSupplierServicePeriodProposalsDialogMutation$variables = {
  input: ConfirmSupplierServicePeriodProposalsInput;
};
export type ConfirmSupplierServicePeriodProposalsDialogMutation$data = {
  readonly confirmSupplierServicePeriodProposals: {
    readonly id: string;
    readonly proposedServicePeriodCount: number;
  };
};
export type ConfirmSupplierServicePeriodProposalsDialogMutation = {
  response: ConfirmSupplierServicePeriodProposalsDialogMutation$data;
  variables: ConfirmSupplierServicePeriodProposalsDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "confirmSupplierServicePeriodProposals",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "proposedServicePeriodCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfirmSupplierServicePeriodProposalsDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfirmSupplierServicePeriodProposalsDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c3fe3985c9f941147fb185f35ec1f91c",
    "id": null,
    "metadata": {},
    "name": "ConfirmSupplierServicePeriodProposalsDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ConfirmSupplierServicePeriodProposalsDialogMutation(\n  $input: ConfirmSupplierServicePeriodProposalsInput!\n) {\n  confirmSupplierServicePeriodProposals(input: $input) {\n    id\n    proposedServicePeriodCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "fed7fbfdee6293d0f63b0cc96952a5b8";

export default node;
